import logoWhite from "../../assets/images/LUMA-WHITE.png";
import {
  FooterWrapper,
  FooterInner,
  Brand,
  FooterCol,
  ColTitle,
  FooterLink,
  FooterText,
  ContactGroup,
  ContactLabel,
  Divider,
  FooterBottom,
  SocialLink,
} from "./styles/Footer.styles";

const InstagramIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
  </svg>
);

function Footer() {
  return (
    <FooterWrapper>
      <FooterInner>
        <Brand>
          <img src={logoWhite} alt="LUMA Yachting" />
          <p>
            Premium yacht brokerage and charter services. Connecting discerning
            clients with the world's finest vessels.
          </p>
        </Brand>

        <FooterCol>
          <ColTitle>Navigation</ColTitle>
          <FooterLink to="/yachts">Yachts</FooterLink>
          <FooterLink to="/brands">Brands</FooterLink>
          <FooterLink to="/new-buildings">New Buildings</FooterLink>
          <FooterLink to="/about">About</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </FooterCol>

        <FooterCol>
          <ColTitle>Services</ColTitle>
          <FooterText>Yacht Sales</FooterText>
          <FooterText>Yacht Charter</FooterText>
          <FooterText>Consultancy</FooterText>
          <FooterText>Fleet Management</FooterText>
        </FooterCol>

        <FooterCol>
          <ColTitle>Contact</ColTitle>
          <ContactGroup>
            <ContactLabel>General</ContactLabel>
            <FooterLink as="a" href="mailto:info@lumayachting.com">
              info@lumayachting.com
            </FooterLink>
            <ContactLabel>Follow us</ContactLabel>
            <SocialLink
              href="https://www.instagram.com/lumayachting/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </SocialLink>
          </ContactGroup>

          {/* <ContactGroup>
            <ContactLabel>Brokers</ContactLabel>
            <FooterLink as="a" href="mailto:luka@lumayachting.com">
              luka@lumayachting.com
            </FooterLink>
            <FooterLink as="a" href="mailto:mz@lumayachting.com">
              mz@lumayachting.com
            </FooterLink>
          </ContactGroup> */}
        </FooterCol>
      </FooterInner>

      <Divider />

      <FooterBottom>
        <p>© {new Date().getFullYear()} LUMA Yachting. All rights reserved.</p>
        <p>Crafted with precision</p>
      </FooterBottom>
    </FooterWrapper>
  );
}

export default Footer;
